// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CheckboxInput_checkboxContainer__TFsjo","checkboxLabel":"CheckboxInput_checkboxLabel__XrKZU"};